import Contact from './Contact.jsx';
import ListContacts from './ListContacts.jsx';

export {Contact, ListContacts}



// WEBPACK FOOTER //
// ./components/contacts/index.js